import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import UnifiedUploadModal from '../../../components/UnifiedUploadModal';

const QuickActions = ({ onUploadSuccess, onViewPayComparison }) => {
  const [showUploadModal, setShowUploadModal] = useState(false);

  const actions = [
    {
      id: 'upload',
      title: 'Upload Data',
      description: 'Import rotation or timecard',
      icon: 'Upload',
      color: 'cyan',
      onClick: () => setShowUploadModal(true)
    },
    {
      id: 'compare',
      title: 'Pay Comparison',
      description: 'Review pay discrepancies',
      icon: 'Calculator',
      color: 'blue',
      onClick: onViewPayComparison
    },
    {
      id: 'sync',
      title: 'Sync Data',
      description: 'Refresh from API',
      icon: 'RefreshCw',
      color: 'purple',
      onClick: () => {}
    }
  ];

  const colorClasses = {
    cyan: 'text-accent-cyan border-accent-cyan/20 bg-accent-cyan/10 hover:border-accent-cyan/40',
    blue: 'text-accent-blue border-accent-blue/20 bg-accent-blue/10 hover:border-accent-blue/40',
    purple: 'text-accent-purple border-accent-purple/20 bg-accent-purple/10 hover:border-accent-purple/40',
    pink: 'text-accent-pink border-accent-pink/20 bg-accent-pink/10 hover:border-accent-pink/40'
  };

  return (
    <>
      <div className="card">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground mb-2">
          Quick Actions
        </h2>
        <p className="text-sm md:text-base font-caption text-muted-foreground mb-6">
          Common tasks and data management
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {actions?.map((action) => (
            <button
              key={action?.id}
              onClick={action?.onClick}
              className={`p-4 md:p-6 rounded-xl border transition-smooth hover:scale-[1.02] ${colorClasses?.[action?.color]}`}
            >
              <div className="flex flex-col items-center text-center gap-3">
                <div className={`flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl border ${colorClasses?.[action?.color]}`}>
                  <Icon 
                    name={action?.icon} 
                    size={24}
                    color={`var(--color-accent-${action?.color})`}
                  />
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-medium text-foreground mb-1">
                    {action?.title}
                  </h3>
                  <p className="text-xs font-caption text-muted-foreground">
                    {action?.description}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <UnifiedUploadModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onUploadSuccess={onUploadSuccess}
      />
    </>
  );
};

export default QuickActions;